<mat-card>
  <div class="row">
    <div class="col-md-10">
<h2>VOUCHERS LIST</h2></div>
<div class="col-md-2">
</div></div>
<div class="row">
  
<div class="col-md-8">
  <mat-form-field class="search">
    <mat-label>Search</mat-label>
    <input (keyup)="applyFilter($event.target.value)" matInput placeholder="Search"   >
    </mat-form-field>
</div>
<div class="col-md-4 text-center">
  <button mat-button (click)="addMember()" class="add">Add New </button>
  </div>
</div>

<table mat-table [dataSource]="memberss" matSort>
    <!-- <ng-container matColumnDef="image">
<th mat-header-cell *matHeaderCellDef mat-sort-header>Image </th>
<td mat-cell *matCellDef="let member" role="gridcell"> </td>
</ng-container> -->
  <ng-container matColumnDef="title">
<th mat-header-cell *matHeaderCellDef mat-sort-header>VOUCHER CODE</th>
<td mat-cell *matCellDef="let member" role="gridcell"><div style="color: black;">{{member.code}}</div> </td>
</ng-container>
  <ng-container matColumnDef="voucherType">
<th mat-header-cell *matHeaderCellDef mat-sort-header>VOUCHER TYPE</th>
<td mat-cell *matCellDef="let member" role="gridcell"> {{member.voucher_type}} </td>
</ng-container>
 
<ng-container matColumnDef="percentage">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>PERCENTAGE</th>
    <td mat-cell *matCellDef="let member" role="gridcell"><ng-container *ngIf="member.Offer_percentage ;else na"> {{member.voucher_percentage}}</ng-container><ng-template #na>N/A</ng-template> </td>
    </ng-container>
 
    <ng-container matColumnDef="fix_amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FIX AMOUNT</th>
        <td mat-cell *matCellDef="let member" role="gridcell"><ng-container *ngIf="member.fixamount; else na1"> {{member.fixamount}}</ng-container><ng-template #na1>N/A</ng-template> </td>
        </ng-container>
         
        <ng-container matColumnDef="start">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>START DATE</th>
            <td mat-cell *matCellDef="let member" role="gridcell"><ng-container *ngIf="member.start ;else na2"> {{member.start | date:'MMM dd yyyy'}}</ng-container><ng-template #na2>N/A</ng-template> </td>
            </ng-container>
            <ng-container matColumnDef="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>END DATE</th>
                <td mat-cell *matCellDef="let member" role="gridcell"><ng-container *ngIf="member.end; else na3"> {{member.end | date:'MMM dd yyyy'}}</ng-container><ng-template #na3>N/A</ng-template> </td>
                </ng-container>
             
                                                 
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
    <td mat-cell *matCellDef="let member" role="gridcell"> {{member.status}} </td>
    </ng-container>
    
    
<ng-container matColumnDef="action"  >
<th mat-header-cell *matHeaderCellDef>ACTION</th>
<td mat-cell *matCellDef="let member" role="gridcell">
<a class="edit" (click)="edit(member.id)"><mat-icon>edit</mat-icon></a>
<button class="dlt" (click)="deleteMember(member.id)"><mat-icon>delete</mat-icon></button>

</td>

</ng-container>

<!--in row which column will display is assigned in displayedColumns-->
<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row  (click)="logData(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
			 </table>
<mat-paginator [length]="15" [pageSize]="5" [pageSizeOptions]="[5,10,15]" showFirstLastButtons></mat-paginator>
</mat-card>